module.exports = __webpack_public_path__ + "static/media/hospitals.8b778f87.svg";